export namespace BwsNb2Write {
  export interface WriteResponse {
    [key: string]: string | undefined;
  }
}

export class BWSNB2WriteParser {
  static parser(
    pos: Record<string, string> | undefined,
    ...keys: string[]
  ): Record<string, string> {
    const result: Record<string, string> = {};

    if (!pos) return result;

    for (const key of keys) {
      const value = pos[key];
      if (value !== undefined) {
        result[key] = value;
      }
    }

    return result;
  }
}
